import React, { useEffect, useLayoutEffect } from 'react';
import Modal from 'react-modal';
import styles from './styles.module.scss';

interface IModalWrapper {
  isOpen: boolean;
  children: JSX.Element;
  // Additional options
  onRequestClose?: () => void;
  onAfterClose?: () => void;
  shouldFocusAfterRender?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
  shouldReturnFocusAfterClose?: boolean;
  className?: string;
}

Modal.setAppElement(window.document.body);

const ModalWrapper = (props: IModalWrapper) => {
  const { className, children, ...restProps } = props;
  const classNameBase = `${styles.base} ${className || ''}`.trim();

  useEffect(() => {
    if (props.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'inherit';
    }
  }, [props.isOpen]);

  return (
    <Modal
      closeTimeoutMS={500}
      className={{
        base: classNameBase,
        afterOpen: '',
        beforeClose: '',
      }}
      overlayClassName={{
        base: styles['base-overlay'],
        afterOpen: '',
        beforeClose: styles['before-close'],
      }}
      {...restProps}
    >
      {children}
    </Modal>
  );
};

export default ModalWrapper;
